import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "moon"
const MoonIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M8.625 7.5C8.625 6.03 8.928 4.632 9.473 3.362 5.733 4.454 3 7.907 3 12 3 16.97 7.03 21 12 21 14.669 21 17.065 19.837 18.713 17.99 13.105 17.774 8.625 13.161 8.625 7.5M10.125 7.5C10.125 12.47 14.155 16.5 19.125 16.5Q19.471 16.5 19.811 16.473H19.946C20.61 16.519 21.109 17.283 20.662 17.935 18.77 20.69 15.597 22.5 12 22.5 6.201 22.5 1.5 17.799 1.5 12 1.5 6.758 5.341 2.416 10.362 1.629 11.195 1.499 11.68 2.392 11.315 3.026 10.56 4.343 10.125 5.87 10.125 7.5" />
        </svg>
      }
    </span>
  )
}
export default MoonIcon
